
































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    HOST
} from "../global";
  // import ICountUp from 'vue-countup-v2';

@Component({
    name: "Achievments",
  //   components: {
  //   ICountUp
  // },
})
export default class Achievments extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    // delay = 1000;
    // showCounter: boolean = false;
    // options: any = {
    //     useEasing: true,
    //     useGrouping: true,
    //     separator: '',
    //     decimal: '.',
    //     prefix: '',
    //     suffix: ''
    // };

 
}
